module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "public",
    attrs: {
      "id": "public"
    }
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.activeNote) ? [_c('header', {
    staticClass: "public__header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.activeNote.name))]), _vm._v(" "), _c('span', [_vm._v("Updated " + _vm._s(_vm._f("prettyDate")(_vm.activeNote.date_modified)))])]), _vm._v(" "), _c('div', {
    staticClass: "public__body",
    domProps: {
      "innerHTML": _vm._s(_vm.body)
    }
  }), _vm._v(" "), _c('footer', {
    staticClass: "public__footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("notational.co")])], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d36cd75c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/Public.vue
// module id = 2188
// module chunks = 0